import { render, staticRenderFns } from "./TCPlayer.vue?vue&type=template&id=19f8fdab&scoped=true"
import script from "./TCPlayer.vue?vue&type=script&lang=js"
export * from "./TCPlayer.vue?vue&type=script&lang=js"
import style0 from "./TCPlayer.vue?vue&type=style&index=0&id=19f8fdab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f8fdab",
  null
  
)

export default component.exports